// LIBRARIES
import { createAsyncThunk } from "@reduxjs/toolkit";

// MISC
import { REST } from "config/axiosConfig";

export const markNotificationsAsRead = createAsyncThunk(
  "notification/markNotificationsAsRead",
  async (notificationsId: string) => {
    try {
      const response = await REST.post(
        `/notification/mark-notifications-as-read?notificationsIds=${notificationsId}`
      );
      return response.data;
    } catch (err) {
      return err;
    }
  }
);

export const getNotifications = createAsyncThunk(
  "notification/getNotifications",
  async (pageNumber: number) => {
    try {
      const response = await REST.get(
        `/notification/get-notifications?page=${pageNumber}&size=20`
      );
      return response.data;
    } catch (err) {
      return err;
    }
  }
);
